// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7errK","right":"styles_right__2fx-4"};